export const DARK_GREEN = 'dark-green';
